import React from 'react';

import { Box } from '@mui/material';

import { OrderBookLevel } from '../../types/orderBook';

const ROW_HEIGHT = 24;

type Props = {
  row: { level: OrderBookLevel; side: 'bid' | 'ask'; index: number };
  isSelected: boolean;
  maxAsk: number;
  maxBid: number;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
};

const OrderBookRow: React.FC<Props> = ({
  row,
  isSelected,
  maxAsk,
  maxBid,
  onMouseEnter,
  onMouseLeave,
  onClick,
  onKeyDown,
}) => {
  const quantity = Number(row.level.quantity);
  const max = row.side === 'ask' ? maxAsk : maxBid;
  const percent = Math.min(1, quantity / max);
  const barColor = row.side === 'ask' ? 'rgba(236, 69, 89, 0.15)' : 'rgba(0, 165, 130, 0.15)';
  const selectedColor = row.side === 'ask' ? 'rgba(236, 69, 89, 0.3)' : 'rgba(0, 165, 130, 0.3)';
  const barStyle = {
    position: 'absolute' as const,
    right: 0,
    top: 0,
    height: '100%',
    width: `${percent * 100}%`,
    background: isSelected ? selectedColor : barColor,
    borderRadius: '8px 0 0 8px',
    zIndex: 1,
    transition: 'width 0.3s ease-in-out, background-color 0.3s ease-in-out',
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        height: ROW_HEIGHT,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease-in-out',
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
        borderTop: '1px solid rgba(0, 0, 0, 0.06)',
      }}
      tabIndex={0}
      aria-label={`Цена ${row.level.price}, лоты ${row.level.quantity}, ${row.side === 'ask' ? 'продажа' : 'покупка'}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <Box
        sx={{
          width: '30%',
          padding: '0 16px',
          fontWeight: 400,
          color: '#222',
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          height: '100%',
        }}
      >
        {Number(row.level.price)}
      </Box>
      <Box
        sx={{
          width: '70%',
          padding: '0 16px',
          textAlign: 'right',
          fontWeight: 400,
          color: '#222',
          position: 'relative',
          zIndex: 2,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Box sx={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '100%', zIndex: 1 }}>
          <Box sx={barStyle} />
        </Box>
        <Box sx={{ position: 'relative', zIndex: 2 }}>{row.level.quantity}</Box>
      </Box>
    </Box>
  );
};

export default React.memo(OrderBookRow);
